/*
 * Copyright (c) 2017 Datarista, Inc.
 */

export const actionTypes = {
  DIALOG_OPEN: 'DIALOG_OPEN',
  DIALOG_CLOSE: 'DIALOG_CLOSE',
};

export function openDialog(id, accountId) {
  const action = {
    type: actionTypes.DIALOG_OPEN,
    id,
    accountId,
    show: true,
  };
  return dispatch => {
    dispatch(action);
  };
}

export function closeDialog(id) {
  const action = {
    type: actionTypes.DIALOG_CLOSE,
    id,
    show: false,
  };
  return dispatch => {
    dispatch(action);
  };
}
